let accordionClassNameOpen = "accordion_open";
class JollyAccordion extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      accordionHeader: this.querySelector(".jc-accordion__header"),
      accordionWrapper: this.closest(".jc-accordion-wrapper"),
      accordionContentWrapper: this.querySelector(
        ".jc-accordion__content-wrapper"
      ),
      accordionContent: this.querySelector(".jc-accordion__content"),
    };

    if (this.hasAttribute("data-accordion-open")) {
      this.openAccordion();
    }

    // Event listeners
    this.elements.accordionHeader.addEventListener("click", (evt) => {
      if (this.isClosed()) {
        this.closeAllAccordions();
        this.openAccordion();
      } else {
        this.closeAccordion();
      }
    });
  }

  isOpen() {
    return this.classList.contains(accordionClassNameOpen);
  }
  isClosed() {
    return !this.isOpen();
  }

  openAccordion() {
    this.classList.add(accordionClassNameOpen);
    this.elements.accordionContentWrapper.style.height = `${this.elements.accordionContent.offsetHeight}px`;
  }

  closeAccordion() {
    this.classList.remove(accordionClassNameOpen);
    this.elements.accordionContentWrapper.style.height = "0";
  }

  closeAllAccordions() {
    const wrapperAccordions =
      this.elements.accordionWrapper.querySelectorAll(".jc-accordion");

    wrapperAccordions.forEach((accordion) => {
      accordion.closeAccordion();
    });
  }
}

// Global event listener for all accordions wrapper
window.addEventListener("mousemove", updateAccordionSize);
window.addEventListener("scroll", updateAccordionSize);
window.addEventListener("resize", updateAccordionSize);

function updateAccordionSize() {
  document.querySelectorAll(".jc-accordion__content-wrapper").forEach((item) => {
    if (item.style.height != "0px") {
      item.style.height =
        item.querySelector(".jc-accordion__content").scrollHeight + "px";
    }
  });
}

if (!customElements.get("jolly-accordion")) {
  customElements.define("jolly-accordion", JollyAccordion);
}
